export class CreateCartResponse {
  /**
   * @param {Object} data
   * @param {string} data.cartId
   */
  constructor({ cartId }) {
    this.shoppingCartId = cartId
  }
}
